import React from 'react';
import { Container, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useEffect, useState } from "react";
import axios from 'src/utils/axios';
import logger from 'src/utils/logger';


const PickArea = ({ takeDamages, getDamages, takePerspective, setProductDamages, Product, FisNo }) => {


  const [basePath, setBasePath] = useState('');
  const [perspective, setPerspective] = useState('front');
  const [damages, setDamages] = useState(null);
  const [navigator, setNavigator] = useState({});


  useEffect(() => {
    let isMounted = true;

    axios.get(`/GetProductDetection/${FisNo}`)
      .then(res => {
        if (isMounted) {
          if (typeof res.data === 'string') {
            setDamages([]);
          }
          else {
            setDamages(res.data);
          }
        }
      })
      .catch(error => {
        logger.error("Product detection error:", error.message);
      });

    return () => {
      isMounted = false;
    };
  }, [FisNo])

  useEffect(() => {
    let path = `${process.env.PUBLIC_URL}/assets/products/${Product}`;
    setBasePath(path);
    setDamages([]);
    if (Product === 'tv') {
      setPerspective('front');
      setNavigator(
        {
          'up': {
            'front': 'back',
            'back': 'front',
          },
          'right': {
            'front': 'back',
            'back': 'front',
          },
          'down': {
            'front': 'back',
            'back': 'front',
          },
          'left': {
            'front': 'back',
            'back': 'front',
          }
        }
      );
    }
    else if (Product === 'cookTop') {
      setPerspective('top');
      setNavigator(
        {
          'up': {
            'top': 'bottom',
            'bottom': 'top',
          },
          'right': {
            'top': 'bottom',
            'bottom': 'top',
          },
          'down': {
            'top': 'bottom',
            'bottom': 'top',
          },
          'left': {
            'top': 'bottom',
            'bottom': 'top',
          }
        }
      );
    }
    else {
      setPerspective('front');
      setNavigator(
        {
          'up': {
            'top': 'back',
            'front': 'top',
            'right': 'top',
            'back': 'top',
            'left': 'top',
            'bottom': 'front',
          },
          'right': {
            'top': 'left',
            'front': 'right',
            'right': 'back',
            'back': 'left',
            'left': 'front',
            'bottom': 'right',
          },
          'down': {
            'top': 'front',
            'front': 'bottom',
            'right': 'bottom',
            'back': 'bottom',
            'left': 'bottom',
            'bottom': 'back',
          },
          'left': {
            'top': 'right',
            'front': 'left',
            'right': 'front',
            'back': 'right',
            'left': 'back',
            'bottom': 'left',
          }
        }
      );
    }
  }, [Product])

  const pickPiece = (pickedPiece) => {
    let filteredByPerspective = damages.filter(item => item.perspective === perspective);
    let result = filteredByPerspective.filter(item => item.piece === pickedPiece);
    if (result.length === 0) {
      let pDamage = { piece: pickedPiece, perspective: perspective }
      setDamages([...damages, pDamage]);
    }
    else {
      let result = filteredByPerspective.filter(item => item.piece !== pickedPiece);
      setDamages(result);
    }
  }

  useEffect(() => {
    takePerspective(perspective);
  }, [perspective, takePerspective])

  useEffect(() => {
    if(!damages){
      return
    }
    setProductDamages(damages);
  }, [damages, setProductDamages])

  useEffect(() => {
    if (getDamages === true) {
      takeDamages(damages);
    }
  }, [getDamages, damages, takeDamages])

  const isPicked = (qPiece) => {
    let filteredByPerspective = damages.filter(item => item.perspective === perspective);
    let result = filteredByPerspective.filter(item => item.piece === qPiece);
    if (result.length === 0) {
      return false;
    }
    else {
      return true;
    }
  }

  const capitalize = (word) => {
    return word.charAt(0).toUpperCase() + word.slice(1);
  }

  const useStyles = makeStyles({
    container: {
      paddingTop: 5,
      paddingBottom: 5,
    },
    imgGrid: {
      backgroundColor: 'orange',
    },
    img: {
      width: '100%',
      height: '100%',
      border: '1px solid red',
      zIndex: -1
    },
    picked: {
      objectFit: 'cover',
      opacity: 0.7,
      backgroundColor: 'blue'
    },
    lrBtn: {
      display: 'flex',
      alignItems: 'center',
      height: '100%'
    },
  });

  const classes = useStyles();
  return (
    <>{damages &&
      <Container maxWidth={'xs'} className={classes.container}>
        <Grid container>
          <Grid item xs={12} align='center' onClick={() => { setPerspective(navigator['up'][perspective]) }}>
            <img width="36" height="36" src={process.env.PUBLIC_URL + '/assets/arrows/up.png'} alt="" />
          </Grid>
          <Grid item xs={1} onClick={() => { setPerspective(navigator['left'][perspective]) }}>
            <Grid container className={classes.lrBtn}>
              <img width="36" height="36" src={process.env.PUBLIC_URL + '/assets/arrows/left.png'} alt="" />
            </Grid>
          </Grid>
          <Grid item xs={10}>
            <Grid container>
              < Grid item xs={4} className={classes.imgGrid}>
                <img onClick={() => { pickPiece('0x0') }} className={`${classes.img} ${isPicked('0x0') ? classes.picked : null}`} src={`${basePath}/${perspective}/0x0.jpg`} alt="" />
              </Grid>
              < Grid item xs={4} className={classes.imgGrid}>
                <img onClick={() => { pickPiece('0x1') }} className={`${classes.img} ${isPicked('0x1') ? classes.picked : null}`} src={`${basePath}/${perspective}/0x1.jpg`} alt="" />
              </Grid>
              < Grid item xs={4} className={classes.imgGrid}>
                <img onClick={() => { pickPiece('0x2') }} className={`${classes.img} ${isPicked('0x2') ? classes.picked : null}`} src={`${basePath}/${perspective}/0x2.jpg`} alt="" />
              </Grid>
              < Grid item xs={4} className={classes.imgGrid}>
                <img onClick={() => { pickPiece('1x0') }} className={`${classes.img} ${isPicked('1x0') ? classes.picked : null}`} src={`${basePath}/${perspective}/1x0.jpg`} alt="" />
              </Grid>
              < Grid item xs={4} className={classes.imgGrid}>
                <img onClick={() => { pickPiece('1x1') }} className={`${classes.img} ${isPicked('1x1') ? classes.picked : null}`} src={`${basePath}/${perspective}/1x1.jpg`} alt="" />
              </Grid>
              < Grid item xs={4} className={classes.imgGrid}>
                <img onClick={() => { pickPiece('1x2') }} className={`${classes.img} ${isPicked('1x2') ? classes.picked : null}`} src={`${basePath}/${perspective}/1x2.jpg`} alt="" />
              </Grid>
              < Grid item xs={4} className={classes.imgGrid}>
                <img onClick={() => { pickPiece('2x0') }} className={`${classes.img} ${isPicked('2x0') ? classes.picked : null}`} src={`${basePath}/${perspective}/2x0.jpg`} alt="" />
              </Grid>
              < Grid item xs={4} className={classes.imgGrid}>
                <img onClick={() => { pickPiece('2x1') }} className={`${classes.img} ${isPicked('2x1') ? classes.picked : null}`} src={`${basePath}/${perspective}/2x1.jpg`} alt="" />
              </Grid>
              < Grid item xs={4} className={classes.imgGrid}>
                <img onClick={() => { pickPiece('2x2') }} className={`${classes.img} ${isPicked('2x2') ? classes.picked : null}`} src={`${basePath}/${perspective}/2x2.jpg`} alt="" />
              </Grid>
              {
                Product === 'tv' ?
                  <>
                    < Grid item xs={4} className={classes.imgGrid}>
                      <img onClick={() => { pickPiece('3x0') }} className={`${classes.img} ${isPicked('3x0') ? classes.picked : null}`} src={`${basePath}/stand${capitalize(perspective)}/0x0.jpg`} alt="" />
                    </Grid>
                    < Grid item xs={4} className={classes.imgGrid}>
                      <img onClick={() => { pickPiece('3x1') }} className={`${classes.img} ${isPicked('3x1') ? classes.picked : null}`} src={`${basePath}/stand${capitalize(perspective)}/0x1.jpg`} alt="" />
                    </Grid>
                    < Grid item xs={4} className={classes.imgGrid}>
                      <img onClick={() => { pickPiece('3x2') }} className={`${classes.img} ${isPicked('3x2') ? classes.picked : null}`} src={`${basePath}/stand${capitalize(perspective)}/0x2.jpg`} alt="" />
                    </Grid>
                  </>
                  : null
              }
            </Grid>
          </Grid>
          <Grid item xs={1} onClick={() => { setPerspective(navigator['right'][perspective]) }}>
            <Grid container className={classes.lrBtn}>
              <img width="36" height="36" src={process.env.PUBLIC_URL + '/assets/arrows/right.png'} alt="" />
            </Grid>
          </Grid>
          <Grid item xs={12} align='center' onClick={() => { setPerspective(navigator['down'][perspective]) }}>
            <img width="36" height="36" src={process.env.PUBLIC_URL + '/assets/arrows/down.png'} alt="" />
          </Grid>
        </Grid>
      </Container>
    }
    </>
  );
}

export default PickArea;
